import React, { useState } from 'react';
import { Row, Col, Button, Container, TabContent, TabPane, ButtonGroup } from 'reactstrap';
import _ from 'lodash';
import Modal from 'reactstrap/lib/Modal';
import ModalBody from 'reactstrap/lib/ModalBody';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import Block from '../common/Display/Block';
import pricingIcon from '../../assets/img/pricing.png';
import { usePricing } from '../../hooks/usePricing/usePricing';
import { PricingTab } from './PricingTab';
import CoverageRequest from './CoverageRequest';
import { t } from '../common/Translate';

const Pricing = (props) => {
  const [redirect, setRedirect] = useState(false);
  const { tabs, activeTab, recordId, locked, user, onBackButton } = usePricing();

  return (
    <>
      {redirect && <Redirect to={redirect} />}
      {locked && <ModalLocked user={user} recordId={recordId} setRedirect={setRedirect} />}
      <Block {...props} backRoute={_.set(props, 'location.state.from', `/files/${recordId}`)}>
        <div className="page pricing responsive-page-pricing">
          <Container fluid className="pb-3">
            <Row className="pricing-title">
              <Col>
                <div onClick={onBackButton} aria-hidden>
                  <FontAwesomeIcon className="back-button" size="2x" icon={faArrowLeft} data-cy="backButton" />
                </div>
                <img src={pricingIcon} alt="" height="25" className="align-top mt-1 ml-5" />{' '}
                <ButtonGroup>
                  {tabs.map((tab) => (
                    <Button
                      key={tab.name}
                      onClick={tab.onClick}
                      color="primary"
                      className="tab-pricing"
                      outline={!tab.active}
                    >
                      {tab.name}
                    </Button>
                  ))}
                </ButtonGroup>
              </Col>
            </Row>
            <TabContent activeTab={activeTab}>
              <TabPane tabId="pricing_title">
                <PricingTab />
              </TabPane>
              <TabPane tabId="coverageRequest">
                <CoverageRequest />
              </TabPane>
            </TabContent>
          </Container>
        </div>
      </Block>
    </>
  );
};
export default Pricing;

const ModalLocked = (props) => {
  const { user, recordId, setRedirect } = props;

  const redirect = () => {
    setRedirect(`/files/${recordId}`);
  };

  return (
    <>
      <Modal isOpen centered>
        <ModalBody className="modal-body test">
          <h5>{t('titleSupervisorPopUp')}</h5>
          <div className="mt-4">
            <span className="lead">{t('textSupervisorPopUp')}</span>
            <span className="ml-2 lead">
              <strong>{user}.</strong>
            </span>
          </div>
          <div className="row">
            <div className="col text-center">
              <button type="button" className="btn btn-outline-primary mt-4 align-middle" onClick={redirect}>
                {t('close')}
              </button>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

ModalLocked.propTypes = {
  user: PropTypes.string.isRequired,
  recordId: PropTypes.number.isRequired,
  setRedirect: PropTypes.func.isRequired,
};
